import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Pagination } from 'app/_models/pagination.model';
import { SiteFormResponse } from 'app/_models/site-forms/site-form-response.model';
import { SiteFormsService } from 'app/_services/site-forms.service';
import { PdfExportService } from 'app/_services/pdf-export.service';
import { FileService } from 'app/_services/file.service';
import { Globals } from 'app/_globals';

@Component({
  selector: 'app-session-photo-modal',
  templateUrl: './site-form-modal.component.html',
})
export class SiteFormModalComponent implements OnInit {
  public sessionId?: number; // passed in on creation
  public siteOwnerLogin?: string; //passed in on creation

  public title = 'Site Forms';
  public siteFormResponses: SiteFormResponse[] = [];
  public selectedResponse: SiteFormResponse;
  public logoUrl: string;
  public isLoading = true;
  public includePhotos: boolean = true;
  public downloadClicked = false;

  constructor(
    private siteFormsService: SiteFormsService,
    private activeModal: NgbActiveModal,
    private pdfExportService: PdfExportService,
    private fileService: FileService,
    private globals: Globals,
  ) { }

  ngOnInit() {
    if (this.sessionId) {
      const pagination: Pagination = {
        size: 10000,
        page: 0,
        totalRecords: 0,
      };
      this.siteFormsService.getAllResponsesByUserSessionId(this.sessionId, pagination, []).subscribe(data => {
        this.siteFormResponses = data.body;
        this.isLoading = false;
      });
    }
    this.title = "Site Forms for Session: " + this.sessionId;
    this.logoUrl = this.siteFormsService.getSiteOwnerLogo(this.siteOwnerLogin);
  }

  public viewResponse(response: SiteFormResponse) {
    this.downloadClicked = false;
    this.selectedResponse = response;
  }

  public async downloadPDF() {
    this.downloadClicked = true; // when images are present, downloading a second time can cause an error - prevent double download
    this.pdfExportService.createPdfFromSiteFormResponse(this.selectedResponse, this.logoUrl, this.includePhotos);
  }

  public openAttachment(file) {
    this.fileService.showFile(this.globals.fileFolder.siteFormResponseFiles, file);
  }

  public closeModal() {
    this.activeModal.dismiss();
  }
}
